var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveIconBrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.15 12.553H2.317a1.262 1.262 0 01-1.262-1.262V2.457a1.262 1.262 0 011.262-1.262h6.94l3.155 3.155v6.94a1.262 1.262 0 01-1.262 1.263z",
    stroke: "#502150",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.888 12.553V7.506h-6.31v5.047M3.578 1.195V4.35h5.048",
    stroke: "#575757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgSaveIconBrown;